exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kfw .row {\n  padding: 10px; }\n\n.kfw-odd {\n  background-color: #ededed; }\n\n.kfw button {\n  width: 100%; }\n", ""]);

// exports
